import NotificationListPage from "@/components/notifications/NotificationListPage"

const MarketingNotification = () => (
    <NotificationListPage title="Thông báo" scope="mine" accent="rose" />
)

export default MarketingNotification
